<template lang="pug">
.form-item(:class="{'-error-': error}")
  span.form-item__title(v-if="title")
    | {{title}}
  .form-item__block(v-click-outside="close")
    span.form-item__error(v-if="typeof error !== 'boolean'")
      | {{error}}

    .form-item__select.select( :class="{'-error__class-': error}" @click="toggleOpen")
      p.select__text( :class="value ? '' : 'select__text-placeholder'" :aria-placeholder="placeholder")
        | {{result}}

    SlideUpDown.select__slider(
      :duration="slideDuration"
      :active="isOpen" v-if="!disabled"
    )
      input.msg-select( v-model="newData" :placeholder="infoAdd ? infoAdd : 'Добавить'")
      .select__field.-no-padding-
        .select__item(
        v-for="(selectItem, idx) in selectData" :key="idx" :style="addIcon(selectItem)"
        @click="setOption( selectItem )",
        )
          Avatar(v-if="selectItem.avatar || selectItem.icon" :img="selectItem.avatar || selectItem.icon" cicrle size="s")
          p.select__text
            | {{selectItem.name}}

    Icon.form-item__icon(:icon="!icon ? 'arrow-down' : icon")

</template>

<script>
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';

export default {
  directives: { clickOutside: vClickOutside.directive },
  components: { SlideUpDown },
  props: {
    value: {},
    selectData: {
      type: Array,
      default: () => [{ text: '', value: '' }]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {},
    error: {},
    icon: {},
    placeholder: {},
    message: {},
    infoAdd: {}
  },
  data: () => ({
    isOpen: false,
    result: '',
    slideDuration: 200,
    newData: ''
  }),
  watch: {
    selectData() {
      const index = this.selectData.findIndex(item => item.id === this.value);
      this.result =
        index !== -1
          ? this.selectData[index].name
          : this.placeholder
          ? this.placeholder
          : 'Выберете поле';
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.selectData.length > 0 && !this.message) {
        const index = this.selectData.findIndex(item => item.id === this.value);
        this.result =
          index !== -1
            ? this.selectData[index].name
            : this.placeholder
            ? this.placeholder
            : 'Выберете поле';
      }
    }, 0);
  },
  methods: {
    close() {
      this.isOpen = false;
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    setOption(data) {
      this.close();

      this.result = data.name;
      this.$emit('input', data);
    },
    addIcon({ icon }) {
      if (icon) {
        return {
          backgroundImage: `url(${icon})`,
          backgroundColor: 'grey',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        };
      } else {
        return {};
      }
    }
  }
};
</script>
